import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";
import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { CommandPalette } from "./CommandPalette";
import { SidebarInset, SidebarProvider } from "@/shared/components/ui/sidebar";
import { VerificationBanner } from "@/shared/components/feedback/VerificationBanner";
import { OnboardingProvider } from "@/shared/components/onboarding/OnboardingProvider";
import { SpotlightOverlay } from "@/shared/components/onboarding/SpotlightOverlay";
import { OnboardingChecklist } from "@/shared/components/onboarding/OnboardingChecklist";

export function AppLayout() {
  const location = useLocation();

  return (
    <OnboardingProvider>
      <SidebarProvider>
        <Sidebar />
        <CommandPalette />
        <SidebarInset className="flex flex-col h-dvh overflow-hidden w-full">
          <VerificationBanner />
          <Header />
          <main className="flex-1 min-h-0 flex flex-col overflow-hidden p-4 sm:p-6" tabIndex={0}>
            <AnimatePresence mode="wait">
              <motion.div
                key={location.pathname}
                className="flex-1 min-h-0 flex flex-col"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.15 }}
              >
                <Outlet />
              </motion.div>
            </AnimatePresence>
          </main>
        </SidebarInset>
        <OnboardingChecklist />
        <SpotlightOverlay />
      </SidebarProvider>
    </OnboardingProvider>
  );
}
